import { render, staticRenderFns } from "./ReleaseNotice.vue?vue&type=template&id=427812f0"
import script from "./ReleaseNotice.vue?vue&type=script&lang=js"
export * from "./ReleaseNotice.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotice.vue?vue&type=style&index=0&id=427812f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports